Bingo.OfferFilterForm = {
    preventFilter: false,
    mobileFilterOpened: false,
    moreFiltersOpened: false,
    scrollPos: 0,
    mobileFilterOpenPos: 0,
    lastScrollPos: 0,
};

Bingo.OfferFilterForm.clearInputs = function ($el) {
    $el.find(':input').not(':button, :submit, :reset').each(function () {
        const $input = $(this);

        // Skip "do" parameter of Nette form
        if ($input.attr('name') === 'do' || $input.attr('name') === '_do') {
            return;
        }

        if ($input.is(':checkbox') || $input.is(':radio')) {
            $input.prop('checked', false);
        } else if ($input.is('select')) {
            $input.find('option:selected').prop('selected', false);
            if ($input[0].selectize !== undefined) {
                $input[0].selectize.clear();
            }
        } else {
            $input.val(null);
        }
    });
};

Bingo.OfferFilterForm.hideMobileFilters = function () {
    const mapInstance = Bingo.Map.getInstance('offer-search-map');
    const offerFilter = $('.js-offerFilter');
    const button = $('.js-offerFilter-mobileFilterButton');
    if (Bingo.OfferFilterForm.mobileFilterOpened) {
        offerFilter.removeClass('-mobileFilterOpen');
        button.text(button.attr('data-show-text'));
        button.removeClass('-secondary').addClass('-primary');
        Bingo.OfferFilterForm.mobileFilterOpened = false;
    }
    mapInstance.onResize();
    this.resizeMoreFilters();
};

Bingo.OfferFilterForm.showMobileFilters = function () {
    const mapInstance = Bingo.Map.getInstance('offer-search-map');
    const offerFilter = $('.js-offerFilter');
    const button = $('.js-offerFilter-mobileFilterButton');
    if (!Bingo.OfferFilterForm.mobileFilterOpened) {
        Bingo.OfferFilterForm.mobileFilterOpenPos = Bingo.OfferFilterForm.scrollPos;
        offerFilter.addClass('-mobileFilterOpen');
        button.text(button.attr('data-hide-text'));
        button.removeClass('-primary').addClass('-secondary');
        Bingo.OfferFilterForm.mobileFilterOpened = true;
    }
    mapInstance.onResize();
    this.resizeMoreFilters();
};

Bingo.OfferFilterForm.resizeMoreFilters = function () {
    const headerHeight = $('.js-layout__header').height();
    const windowHeight = window.innerHeight;
    const height = windowHeight - headerHeight;
    $('.js-offerFilter__filterAddition').css('top', this.isDesktop() ? '' : `${headerHeight - 1}px`);
    $('.js-offerFilter__moreFilters').css('max-height', this.isDesktop() ? `${height}px` : 'auto');
};

Bingo.OfferFilterForm.isDesktop = function () {
    return window.matchMedia('(min-width: 991px)').matches;
};

(function ($) {
    function initValues($el) {
        $el.find(':input').not('[type="hidden"], :button, :submit, :reset').each(function () {
            const $input = $(this);
            if ($input.is(':checkbox') || $input.is(':radio')) {
                $input.attr('data-value', $input.is(':checked'));
            } else {
                $input.attr('data-value', $input.val());
            }
        });
    }

    function setCallbacksOn($el, btnClass) {
        $el.find(btnClass).filter(':input').on('change', function () {
            if (Bingo.OfferFilterForm.preventFilter !== true) {
                const $form = $(this).closest('form');

                if ($(this).hasClass('redraw')) {
                    $('[name="redraw"]').click();
                }

                if ($(this).hasClass('submit') && Nette.isValid($form[0])) {
                    const $buttons = $('[name="filter"]');
                    if ($buttons.length > 0) {
                        $buttons[0].click();
                    }
                }
            }
        });
    }

    function toggleMobileFilters() {
        const offerFilter = $('.js-offerFilter');
        if (offerFilter.hasClass('-mobileFilterOpen')) {
            Bingo.OfferFilterForm.hideMobileFilters();
        } else {
            Bingo.OfferFilterForm.showMobileFilters();
        }
    }

    function showMoreFilters() {
        const body = $('body,html');
        const button = $('.js-offerFilter-mobileFilterButton');
        const moreFilter = $('.js-offerFilter-mobileMoreFilterButton');
        const buttonDesktop = $('.js-offerFilter__moreFiltersButton');
        toggleMobileFilters();
        $('.js-offerFilter__moreFilters').removeClass('d-none');
        $('.js-offerFilter').addClass('-moreFiltersShowed');
        body.css('overflow', 'hidden');
        button.hide();
        moreFilter.show();
        buttonDesktop.removeClass('-primary').addClass('-secondary');
        Bingo.OfferFilterForm.moreFiltersOpened = true;
        window.scrollTo(0, 1);
        Bingo.OfferFilterForm.resizeMoreFilters();
    }

    function hideMoreFilters() {
        const button = $('.js-offerFilter-mobileFilterButton');
        const moreFilter = $('.js-offerFilter-mobileMoreFilterButton');
        const buttonDesktop = $('.js-offerFilter__moreFiltersButton');
        $('.js-offerFilter__moreFilters').addClass('d-none');
        $('.js-offerFilter').removeClass('-moreFiltersShowed');
        $('body,html').css('overflow', '');
        button.show();
        moreFilter.hide();
        buttonDesktop.removeClass('-secondary').addClass('-primary');
        Bingo.OfferFilterForm.moreFiltersOpened = false;
    }

    $.nette.ext('offer-filter-form', {
        init() {
            this.ext('snippets', true).after($.proxy(($el) => {
                setCallbacksOn($el, '.re.redraw, .re.submit');

                if ($el.closest('.dropdown').length > 0) {
                    initValues($el);
                }
            }, this));

            setCallbacksOn($('form'), '.redraw, .submit');
            initValues($('.js-moreFilters'));
            this.hideBtnSaveIfLocationOrTypeIsEmpty();
        },
        complete(jqXHR, status, settings) {
            if (/\/en|fr|de\/search\/offers/i.test(settings.url)) {
                this.hideBtnSaveIfLocationOrTypeIsEmpty();
            }
        },
    }, {
        hideBtnSaveIfLocationOrTypeIsEmpty() {
            const type = $('[name="type"]').val();
            const coordinates = $('[name="coordinates"]').val();
            const polygon = $('[name="polygon"]').val();
            const localities = $('[name="localityId"]').length > 0 && $('[name="localityId"]')[0].selectize !== undefined ? $('[name="localityId"]')[0].selectize.getValue() : '';

            if ((coordinates === '' && polygon === '' && localities === '') || type === 'any' || type === 'not-selected') {
                $('#btn-save-nodata').show();
                $('#block-save-as-demand .A-button').hide();
                $('#block-save-as-demand .infoText').show();
            } else {
                $('#btn-save-nodata').hide();
                $('#block-save-as-demand .A-button').show();
                $('#block-save-as-demand .infoText').hide();
            }
        },
    });

    $(document).on('click', '.js-showMap-list', () => {
        Bingo.OfferFilterForm.resizeMoreFilters();
    });

    $(window).resize(() => {
        Bingo.OfferFilterForm.resizeMoreFilters();
    });

    $(window).scroll(() => {
        const currentScrollPos = window.pageYOffset;
        const filterPart = $('.js-offerFilter__filterAddition');
        if (Bingo.OfferFilterForm.scrollPos > currentScrollPos || Bingo.OfferFilterForm.isDesktop() || currentScrollPos < 20) {
            filterPart.css('margin-top', '0px');
        } else {
            filterPart.css('margin-top', '-62px');
        }
        Bingo.OfferFilterForm.scrollPos = currentScrollPos;

        if (Bingo.OfferFilterForm.mobileFilterOpened && Bingo.OfferFilterForm.scrollPos < Bingo.OfferFilterForm.mobileFilterOpenPos) {
            Bingo.OfferFilterForm.mobileFilterOpenPos = Bingo.OfferFilterForm.scrollPos;
        }

        if (Bingo.OfferFilterForm.mobileFilterOpened
            && !Bingo.OfferFilterForm.moreFiltersOpened
            && $('.js-offerFilter').hasClass('-listView')
            && (Bingo.OfferFilterForm.mobileFilterOpenPos + 300) < Bingo.OfferFilterForm.scrollPos) {
            toggleMobileFilters();
        }
    });

    $('.js-offerFilter-toggleMobileFilters').click(() => {
        toggleMobileFilters();
    });

    $('.js-offerFilter__moreFilters-close').on('click', () => {
        hideMoreFilters();
    });

    $('.js-offerFilter__moreFilters-toggle').on('click', () => {
        if ($('.js-offerFilter__moreFilters').hasClass('d-none')) {
            showMoreFilters();
        } else {
            hideMoreFilters();
        }
    });

    $('.js-offerFilter__moreFilters button[name="filter"]').on('click', function () {
        initValues($(this).closest('.js-offerFilter__moreFilters'));
    });

    $('.js-offerFilter__moreFilters-clear').on('click', (e) => {
        e.stopPropagation();
        e.preventDefault();

        Bingo.OfferFilterForm.preventFilter = true;
        Bingo.OfferFilterForm.clearInputs($('.js-offerFilter__moreFilters'));
        Bingo.OfferFilterForm.preventFilter = false;
        $('[name="filter"]')[0].click();
        $('[name="redraw"]')[0].click();
    });
}(jQuery));
